import { HttpParams } from '@angular/common/http';
import { Inject, Injectable, Injector, LOCALE_ID } from '@angular/core';
import { DocumentGroups, IUploadedDocument } from '@carm/_core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IUploadedDocumentsList } from '../models/document-types-list.model';
import { mapToUploadedDocuments } from '../models/document.converters';
@Injectable()
export class DocumentsRegistrationEnrolmentService extends BaseApiService { // Documents - Registration/Enrol controller
  constructor(
    protected injector: Injector,
    @Inject(LOCALE_ID) protected localeId: string
  ) {
    super(injector);
  }

  get documentsBUrl(): string {
    return `${this.endPointB}/documents`;
  }

  get documentsUrl(): string {
    return `${environment.baseApiUrls}/documents`;
  }

  public getDocuments(
    caseNumber: string,
    documentGroup: DocumentGroups,
    source: 'ATTACHMENTS' | 'DECISION'
  ): Observable<IUploadedDocument[]> {
    const endpoint = `${this.documentsBUrl}/case/${caseNumber}/group/${documentGroup.toString()}/list`;
    const params = new HttpParams().set('source', source);

    return this.httpAuthGet<IUploadedDocumentsList>(
      endpoint,
      params
    ).pipe(
      map(response =>
        response.documentList.map(document =>
          mapToUploadedDocuments(document, this.localeId)
        )
      )
    );
  }

  public getOrphanDocuments(
    draftId: string,
    documentGroup: DocumentGroups,
    source: 'ATTACHMENTS' | 'DECISION'
  ): Observable<IUploadedDocument[]> {
    const endpoint = `${this.documentsUrl}/${draftId}/group/${documentGroup.toString()}/list`;
    const params = new HttpParams().set('source', source);

    return this.httpAuthGet<IUploadedDocumentsList>(
      endpoint,
      params
    ).pipe(
      map(response =>
        response.documentList.map(document =>
          mapToUploadedDocuments(document, this.localeId)
        )
      )
    );
  }

  public getDocument(
    draftId: string,
    documentGroup: DocumentGroups,
    documentId: string
  ): Observable<Blob> {
    const endPoint = `${this.documentsBUrl}/${draftId}/group/${documentGroup.toString()}/document/${documentId}/download`;
    return this.httpAuthDownloadFile(endPoint);
  }

  public getUploadUrl(caseNumber: string, documentGroup: DocumentGroups): string {
    return `${this.documentsBUrl}/case/${caseNumber}/group/${documentGroup.toString()}/upload`;
  }

  public getUploadUrlOrphan(draftId: string, documentGroup: DocumentGroups): string {
    return `${this.documentsUrl}/${draftId}/group/${documentGroup.toString()}/upload`;
  }
}
